import React, { useState, useEffect } from 'react';

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    
    // Clean up the event listener on component unmount
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' 
    });
  };

  if (!isVisible) return null;

  return (
    <>
      {/* INJECTED STYLES FOR PREMIUM FLOATING BUTTON */}
      <style>
        {`
          .scroll-to-top-btn {
            position: fixed;
            bottom: 40px;
            right: 40px;
            width: 50px;
            height: 50px;
            background-color: var(--color-primary-navy);
            color: var(--color-white);
            border: none;
            border-radius: 50%;
            font-size: 1.5rem;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            box-shadow: 0 10px 20px rgba(0,0,0,0.15);
            z-index: 9999;
            transition: all 0.3s ease;
          }
          
          .scroll-to-top-btn:hover {
            background-color: var(--color-primary-dark);
            transform: translateY(-5px);
            box-shadow: 0 15px 25px rgba(0,0,0,0.25);
          }
          
          /* Adjust for mobile screens so it isn't intrusive */
          @media (max-width: 768px) {
            .scroll-to-top-btn {
              bottom: 20px;
              right: 20px;
              width: 45px;
              height: 45px;
              font-size: 1.2rem;
            }
          }
        `}
      </style>

      <button 
        onClick={scrollToTop} 
        className="scroll-to-top-btn" 
        aria-label="Scroll back to top"
      >
        ↑
      </button>
    </>
  );
};

export default ScrollToTopButton;